export const SubscriptionProducts = [
    {
        title: "Commemorative Stamps",
        desc: "Commemorative stamps are issued to commemorate an event, person or anniversary.",
        products: [
            {
                name: "Mint",
                id: "commemorativeMint"
            },
            {
                name: "Cancelled - Standard",
                id: "cancelledStandard"
            },
            {
                name: "Cancelled - Pictorial",
                id: "commemorativePictorial"
            }
        ]
    },
    {
        title: "Commemorative First Day Cover",
        desc: "",
        products: [
            {
                name: "Unserviced",
                id: "commemorativeUnserviced"
            },
            {
                name: "Serviced - Pictorial",
                id: "commemorativeServiced"
            }
        ]
    },
    {
        title: "Miniature Sheets",
        desc: "",
        products: [
            {
                name: "Mint",
                id: "miniatureMint"
            },
            {
                name: "Cancelled - Standard",
                id: "miniatureCanelledStd"
            },
            {
                name: "Cancelled - Pictorial",
                id: "miniatureCancelledPic"
            }
        ]
    },
    {
        title: "Miniature Sheet First Day Cover",
        desc: "",
        products: [
            {
                name: "Unserviced",
                id: "miniatureUnserviced"
            },
            {
                name: "Serviced - Pictorial",
                id: "miniaturePictorial"
            }
        ]
    },
    {
        title: "Definitive Stamps Sheets",
        desc: "Definitive stamps are the standard postage stamps available over a period of five to seven years.",
        products: [
            {
                name: "Mint",
                id: "definitiveMint"
            },
            {
                name: "Cancelled - Standard",
                id: "definitiveCanelledStd"
            },
            {
                name: "Cancelled - Pictorial",
                id: "definitiveCancelledPic"
            }
        ]
    },
    {
        title: "Definitive First Day Cover",
        desc: "",
        products: [
            {
                name: "Unserviced",
                id: "DefinitiveUnserviced"
            },
            {
                name: "Serviced - Pictorial",
                id: "definitivePictorial"
            }
        ]
    },
    {
        title: "Commemorative Booklets",
        desc: "",
        products: [
            {
                name: "Mint",
                id: "commemorativeBookMint"
            },
            {
                name: "Cancelled - Standard",
                id: "commemorativeCanelledStd"
            },
            {
                name: "Cancelled - Pictorial",
                id: "commemorativeCancelledPic"
            }
        ]
    },
    {
        title: "Definitive Booklets",
        desc: "",
        products: [
            {
                name: "Mint",
                id: "definitiveBookletsMint"
            },
            {
                name: "Cancelled - Standard",
                id: "cencelledStandard"
            }
        ]
    },
    {
        title: "Sheetlets",
        desc: "",
        products: [
            {
                name: "Mint",
                id: "sheetletsMint"
            },
            {
                name: "Cancelled - Standard",
                id: "sheetletsCancelledStandard"
            },
            {
                name: "Cancelled - Pictorial",
                id: "sheetletsCancelledPictorial"
            }
        ]
    },
    {
        title: "Commemorative Self-Adhesive Stamps",
        desc: "",
        products: [
            {
                name: "Mint",
                id: "commemorativeSelfAdhesiveMint"
            },
            {
                name: "Cancelled - Standard",
                id: "commemorativeCancelledStandard"
            },
            {
                name: "Cancelled - Pictorial",
                id: "commemorativeCancelledPictorial"
            }
        ]
    },
    {
        title: "Definitive Self-Adhesive Stamps",
        desc: "",
        products: [
            {
                name: "Mint",
                id: "definitiveSelfAdhesiveMint"
            },
            {
                name: "Cancelled - Standard",
                id: "definitiveCancelledStandard"
            }
        ]
    },
    {
        title: "* Plate Block",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativePlateBlock"
            },
            {
                name: "Definitive",
                id: "definitivePlateBlock"
            }
        ]
    },
    {
        title: "* Traffic Light Block",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativeLightBlock"
            },
            {
                name: "Definitive",
                id: "definitiveLightBlock"
            }
        ]
    },
    {
        title: "* Imprint Block",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativeImprintBlock"
            },
            {
                name: "Definitive",
                id: "definitiveImprintBlock"
            }
        ]
    },
    {
        title: "* Blank Corner Block",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativeBlankBlock"
            },
            {
                name: "Definitive",
                id: "definitiveBlankBlock"
            }
        ]
    },
    {
        title: "Presentation Packs",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativePresentationPack"
            },
            {
                name: "Definitive",
                id: "definitivePresentationPack"
            }
        ]
    },
    {
        title: "Stamp Year Pack",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativeStampPack"
            },
            {
                name: "Definitive",
                id: "definitiveStampPack"
            }
        ]
    },
    {
        title: "FDC Year Pack",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativeFDCPack"
            },
            {
                name: "Definitive",
                id: "definitiveFDCPack"
            }
        ]
    },
    {
        title: "Year Book Standard",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativeYearBookStandard"
            }
        ]
    },
    {
        title: "Year Book Deluxe",
        desc: "",
        products: [
            {
                name: "Commemorative",
                id: "commemorativeYearBookDeluxe"
            }
        ]
    }
];
